import { render, staticRenderFns } from "./toReseller.vue?vue&type=template&id=66196ed3&scoped=true"
import script from "./toReseller.vue?vue&type=script&lang=js"
export * from "./toReseller.vue?vue&type=script&lang=js"
import style0 from "./toReseller.vue?vue&type=style&index=0&id=66196ed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66196ed3",
  null
  
)

export default component.exports